// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","StickyWrapper":"_16MJt1","isSticky":"_2AHkR2","topPadded":"_1d3tAg","StickyContent":"_7jcEsA","fadeInFrames":"_30zZtQ"};